import { render, staticRenderFns } from "./shipping-summary.vue?vue&type=template&id=5a8d6ebf"
import script from "./shipping-summary.vue?vue&type=script&lang=js"
export * from "./shipping-summary.vue?vue&type=script&lang=js"
import style0 from "./shipping-summary.vue?vue&type=style&index=0&id=5a8d6ebf&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8d6ebf')) {
      api.createRecord('5a8d6ebf', component.options)
    } else {
      api.reload('5a8d6ebf', component.options)
    }
    module.hot.accept("./shipping-summary.vue?vue&type=template&id=5a8d6ebf", function () {
      api.rerender('5a8d6ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Shipping/shipping-summary.vue"
export default component.exports